import { z } from 'zod';

export const DashboardStatsSchema = z.object({
    totalAssets: z.number().optional(),
    openRisks: z.number().optional(),
    activeIncidents: z.number().optional(),
    pendingApprovals: z.number().optional(),
});

export const CreateDashboardStatsSchema = DashboardStatsSchema.omit({ id: true });
export const UpdateDashboardStatsSchema = DashboardStatsSchema;